

function WavesDisable(element){
    element.removeClass('waves').removeClass('waves-effect');
}

function WavesInit(){

    Waves.init();
    Waves.attach('.waves');

}

export {WavesInit, WavesDisable}